import isEmpty from "lodash/isEmpty";


const soundcastDef = {
  title: '', // ?
  category: '', // ?
  short_description: '',
  long_description: null, // ??? EditorState.createEmpty(),
  imageURL: '',
  blurredImageURL: '', // null,
  previewImage: '', // null,
  landingPage: false,
  features: [''],

  featuresTitle: '',
  hostTitle: '',
  hostName: '',
  hostBio: '',
  hostImageURL: '',
  hostName2: '',
  hostBio2: '',
  hostImageURL2: '',

  itunesTitle: '',
  itunesOwner: '',
  itunesHost: '',
  itunesLanguage: 'en',
  itunesCategory: [],
  itunesExplicit: false,
  itunesImage: '',

  intro: '', // ?
  outro: '', // ?
  showIntroOutro: false,
  applyHistoricallyIntroOutro: false,
  overlayDuration: 5,

  forSale: false,
  prices: [],
  showTimeStamps: false,
  showSubscriberCount: false,
  showListenCount: true,
  disableComment: false,
  showTrackListOnLandingPage: true,

  confirmationEmail: null, // ??? EditorState.createEmpty(),
  enableSignupEmail: true,

  podcastFeedVersion: null,
  autoSubmitPodcast: false,
  enableFaqOnLandingPage: true,
  enableRatings: true,
  disableSignup: false,

  episodes: {}, // ?
  published: false, // ?

  // // mandatory props (set on create)
  // published,
  // creatorID,
  // publisherID: userInfo.publisherID,
  // date_created: moment().format('X'),
  // last_update,
};

export const soundcast2state = (soundcast = null) => {
  if (isEmpty(soundcast)) {
    return soundcastDef;
  }

  const soundcastState = {};
  for (const key in soundcastDef) {
    soundcastState[key] = (key in soundcast) ? soundcast[key] : soundcastDef[key];
  }
  return soundcastState;
};

